import { createTheme } from "@mui/material/styles";

const Colors = {
  primary: "#FBC02D",
  primaryDisabled: "#FFF9C4",
  secondary: "#1976D2",
  danger: "#C62828",
  mute: "rgba(0, 0, 0, 0.54)",
  darkMute: "#616161",
  textField: "#616161",
  gray: "#424242",
  ///////////////
  white: "#FAFAFA",
  whiteDisabled: "#F5F5F5",
  whiteDisabled2: "#E0E0E0",
  black: "#212121",
  blackDisabled: "#9E9E9E",
};

export const lightTheme = createTheme({
  // direction:'rtl',
  palette: {
    mode: "light",
    primary: {
      main: Colors.primary,
    },
    primaryDisabled: {
      main: Colors.primaryDisabled,
    },
    secondary: {
      main: Colors.secondary,
    },
    danger: {
      main: Colors.danger,
    },
    mute: {
      main: Colors.mute,
    },
    darkMute: {
      main: Colors.darkMute,
    },
    textField: {
      main: Colors.textField,
    },
    gray: {
      main: Colors.gray,
    },

    white: {
      main: Colors.white,
    },
    whiteDisabled: {
      main: Colors.whiteDisabled,
    },
    whiteDisabled2: {
      main: Colors.whiteDisabled2,
    },
    black: {
      main: Colors.black,
    },
    blackDisabled: {
      main: Colors.blackDisabled,
    },
  },
  typography: {
    allVariants: { color: Colors.black },
    fontFamily: [
      "Dana",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
    ].join(","),
  },

  components: {
    MuiSkeleton: { defaultProps: { animation: "wave" } },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
        style: {
          textTransform: "initial",
          // boxShadow: `none`,
        },
      },
    },

    MuiUseMediaQuery: {
      defaultProps: {
        noSsr: true,
      },
    },
  },
  breakpoints: {
    values: {
      xxs: 280, //super small phone
      xs: 320, // small phone
      sm: 450, //phone & tablets
    },
  },
});
export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: Colors.primary,
    },
    primaryDisabled: {
      main: Colors.primaryDisabled,
    },
    secondary: {
      main: Colors.secondary,
    },
    danger: {
      main: Colors.danger,
    },
    mute: {
      main: Colors.whiteDisabled,
    },
    darkMute: {
      main: Colors.white,
    },
    textField: {
      main: Colors.textField,
    },
    gray: {
      main: Colors.whiteDisabled,
    },

    white: {
      main: "#2b2b2b",
    },
    whiteDisabled: {
      main: Colors.whiteDisabled,
    },
    whiteDisabled2: {
      main: Colors.whiteDisabled2,
    },
    black: {
      main: Colors.white,
    },
    blackDisabled: {
      main: Colors.blackDisabled,
    },
  },
  typography: {
    allVariants: { color: Colors.white },
    fontFamily: [
      "Dana",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
    ].join(","),
  },

  components: {
    MuiSkeleton: { defaultProps: { animation: "wave" } },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
        style: {
          textTransform: "initial",
          // boxShadow: `none`,
        },
      },
    },

    MuiUseMediaQuery: {
      defaultProps: {
        noSsr: true,
      },
    },
  },
  breakpoints: {
    values: {
      xxs: 280, //super small phone
      xs: 320, // small phone
      sm: 450, //phone & tablets
    },
  },
});
